import gsap from 'gsap'
import koko from '../koko-framework/koko'
import { v, au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
import { FrequencyAnalysisController } from '../controller/FrequencyAnalysisController'
import { GameTimeController } from '../controller/GameTimeController'
import { FREQUENCY } from '../model/GameModel'
import * as PIXI from 'pixi.js'
import gameState from '../model/GameModel'
import MultiStyleText from 'pixi-multistyle-text'
import { SimpleCustomKeyboard } from '../koko-framework/ui/SimpleCustomKeyboard'
import { keyboardSetup_Fr } from '../model/CustomKeyboard'
import { setupClicker } from '../controller/ButtonController'

export class FrequencyAnalysisView extends koko.view {
    controller = null;
    timeController = null;
    slider = null;
    richText = null;
    clickAllowed = false;
    submissionAllowed = false;

    textScrollStart = 0;
    textScrollMin = 0;
    textScrollDist = 0;
    scrollerStart = 0;
    scrollerMax = 0;

    popOpen = false;
    keyboardOpen = false;

    sliderTweening = false;

    /* constructor (){
        super();
    } */

    buildView (){
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            {name:'gameContainer', type:'container'},

            { type: 'sprite', parent: 'gameContainer', id: 'BG_pattern', name: 'bg', x: -280, y: 0, width: 1326, height: 1355},

            { type: 'sprite', parent: 'gameContainer', id: 'frequency_title', name: 'title', x: 198, y: 286, width: 370, height: 62},

            { type: 'bmptext', parent: 'gameContainer', text: 'Use the frequency analysis method to\ndecipher the following encrypted message.', font: 'typrighter_small', size: 30, tint: 0, name: 'instructions', align:'center', x: vp.centerX, y: 358},

            { type: 'sprite', parent: 'gameContainer', id: 'text_carrier', name: 'message_carrier', x: 158, y: 423, width: 448, height: 204},
            { type: 'container', parent: 'gameContainer', name: 'questionContainer', x: vp.centerX, y: 443},
            { type: 'bmptext', parent: 'gameContainer', text: 'PHRASE', font: 'Bebas_small', size: 36, tint: 0, name: 'scrambledText', align: 'center', x: vp.centerX, y: 460},

            { type: 'shape', name: 'phraseMask', parent: 'gameContainer', fill: 0, x: 170, y: 433, width: 426, height: 183 },

            { type: 'shape', parent: 'gameContainer', name: 'closeKeyboardOutside', x: 0, y: 920, width: 765, height: 600, fill: 0, alpha: 0},

            { name: 'pippetsContainer', parent: 'gameContainer', type: 'container', x: vp.centerX, y: 992 },
            { name: 'sliderContainer', parent: 'gameContainer', type: 'container', x: 0, y: 955 - 275 },
            { name: 'frequencyDataContainer', parent: 'sliderContainer', type: 'container', x: 175, y: 275 },
            { name: 'frequencyDataMask', parent:'gameContainer', type: 'shape', x: -280, y: 690, width: 1326, height: 920 - 640},

            { name: 'scroller', id: 'scroller', parent:'gameContainer', type: 'sprite', width: 8, height: 98, x: 582, y: 440, anchorX: 0.5, anchorY: 0 },

            { type: 'sprite', parent: 'gameContainer', id: 'arrow_left_on', name: 'arrow_left_btn', x: 256, y: 1002, width: 74, height: 42, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', parent: 'gameContainer', id: 'arrow_right_on', name: 'arrow_right_btn', x: 508, y: 1002, width: 74, height: 42, anchorX: 0.5, anchorY: 0.5},

            { type: 'sprite', parent: 'gameContainer', id: 'hint_btn_active', name: 'hint_btn', x: vp.centerX, y: 665, width: 162, height: 55, anchorX: 0.5, anchorY: 0.5},

            { type: 'sprite', parent: 'gameContainer', id: 'checkAnswerOff_btn', name: 'checkAnswer_btn', x: 165, y: 1060, width: 434, height: 105},
        ], this.container);

        this.controller = new FrequencyAnalysisController();
        this.children.scrambledText.text = this.controller.model.scrambledPhrase;
        this.children.scrambledText.anchor.x = 0.5;
        // console.log('bmp text: ', this.children.scrambledText);

        this.children.sliderContainer.mask = this.children.frequencyDataMask;

        let richText = new MultiStyleText(this.controller.model.scrambledPhrase.split('|').join('\n'), 
        {   "default": {
                fontFamily: "Courier New",
                fontSize: "20px",
                fill: "#666666",
                align: "left",
                fontWeight: "bold"
            },
            "blue": {
                fill: "#0055aa"
            }
        });
        richText.x = 180;
        richText.y = 440;
        this.children.gameContainer.addChild(richText);
        richText.mask = this.children.phraseMask;
        this.richText = richText;
        this.children.scrambledText.visible = false;

        this.textScrollStart = richText.y;
        let scrollDist = (richText.height - this.children.phraseMask.height) + 15;
        if (scrollDist < 0) {
            scrollDist = 0;
            this.children.scroller.visible = false;
            this.children.scroller.interactive = false;
        }
        this.textScrollDist = scrollDist;
        this.textScrollMin = this.textScrollStart - scrollDist;

        this.scrollerStart = this.children.scroller.y;
        let scrollerTopBuffer = this.children.scroller.y - this.children.phraseMask.y;
        let scrollArea = this.children.phraseMask.height - scrollerTopBuffer * 2;
        let scrollerHeight = 200 * this.children.phraseMask.height / richText.height;
        if (scrollerHeight < 20) {
            scrollerHeight = 20;
        }
        this.children.scroller.height = scrollerHeight;
        let scrollerMovement = scrollArea - this.children.scroller.height;
        this.scrollerMax = /*this.scrollerStart + */scrollerMovement;

        this.buildFrequencyDataDisplay();
        this.createPippets(this.children.pippetsContainer, 5);

        this.children.instructions.anchor.x = 0.5;

        this.submissionAllowed = false;

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.closeKeyboardOutside.interactive = true;
        this.children.closeKeyboardOutside.on(event, () => {if (this.keyboardOpen) {au.play('button', 1, false);} this.closeKeyboard()});

        this.children.hint_btn.interactive = true;
        this.children.hint_btn.on(event, () => {if (!this.popOpen) {au.play('button', 1, false);} this.showHint()});
        */
        setupClicker(this.children.closeKeyboardOutside, () => {if (this.keyboardOpen) {au.play('button', 1, false);} this.closeKeyboard()});
        setupClicker(this.children.hint_btn, () => {if (!this.popOpen) {au.play('button', 1, false);} this.showHint()});

        this.resize();
    }

    resize () {
        // console.log('resize called');
        this.showHideSliderContent();
    }

    transitionIn (){
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35});
        
        v.get('ingamehud').transitionIn(this);

        this.timeController = new GameTimeController();
        this.timeController.init(FREQUENCY.time);

        this.startGame();

        this.enableSlider();
        window.addEventListener('keydown', this.keyPressed);

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.arrow_left_btn.on(event, this.prevPage);
        this.children.arrow_left_btn.interactive = true;
        this.children.arrow_right_btn.on(event, this.nextPage);
        this.children.arrow_right_btn.interactive = true;

        this.children.checkAnswer_btn.interactive = true;
        this.children.checkAnswer_btn.on(event, this.submitAnswer);
        */
        setupClicker(this.children.arrow_left_btn, this.prevPage);
        setupClicker(this.children.arrow_right_btn, this.nextPage);
        setupClicker(this.children.checkAnswer_btn, this.submitAnswer);

        this.keyboardOpen = false;

        this.showTutorial();
    }

    transitionOut (){
        document.onmouseleave = null;
        document.onpointerleave = null;
        document.onmouseup = null;
        document.onpointerup = null;

        this.closeKeyboard();
        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
        v.get('ingamehud').transitionOut();
        this.stopGame();

        window.removeEventListener('keydown', this.keyPressed);
        this.popOpen = false;
    }

    transitionOutDone = () => {
        // gsap.killAll();
        
        this.clearSlider();

        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    startGame () {
        this.enable();
   
        app.removeUpdateListener('ingame');

        /*
        game = new GameController();
        */
        // game.init();
           
        
		app.addUpdateListener('ingame', function(delta){ 
            this.update(delta);
        }.bind(this));
        

        app.addResizeListener('ingame', function(){
            this.resize();
        }.bind(this));
    }

    stopGame (){ 
        app.removeUpdateListener('ingame');
        while (app.updateListeners['ingame']) {
            app.removeUpdateListener('ingame');
        }

        app.removeResizeListener('ingame');
        while (app.resizeListeners['ingame']) {
            app.removeResizeListener('ingame');
        }
    }

    update($delta) {
        if (!this.popOpen) {
            this.timeController.update($delta);
            if (this.slider) {
                this.updatePippets();
            }
            this.clickAllowed = true;
        } else {
            this.clickAllowed = false;
            this.timeController.pauseUpdate($delta);
        }
        this.dragInertia();
        if (this.sliderTweening) {
            this.showHideSliderContent();
        }
    }

    pippetSpacing = 25;

    FREQUENCY_DISPLAYS_SPACING = 84;
    MAX_BAR_HEIGHT = 196;
    buildFrequencyDataDisplay() {
        // let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        let contX = 42;
        for (let i = 0; i < 26; i++) {
            let displayContainer = new PIXI.Container();
            displayContainer.x = contX;
            this.children.frequencyDataContainer.addChild(displayContainer);
            this.children['frqCont_' + i] = displayContainer;
            let displayContChildren = koko.display.buildLayout([
                { type: 'sprite', id: 'frequency_bar', name: 'frequency_bar_' + i, x: 0, y: -142, width: 74, height: 206, anchorX: 0.5, anchorY: 1},
                { type: 'sprite', id: 'letterbox_missing', name: 'letterbox_' + i, x: -27, y: -53, width: 53, height: 53},
                { type: 'bmptext', text: '0%', font: 'typrighter_small', size: 22, tint: 0, name: 'frequency_perc_' + i, align:'center', x: 0, y: -137, anchorX: 0.5, anchorY: 0},
                { type: 'bmptext', text: 'A', font: 'Bebas_small', size: 40, tint: 0, name: 'frequency_lett_' + i, align:'center', x: 0, y: -103, anchorX: 0.5, anchorY: 0},
                { type: 'bmptext', text: 'Q', font: 'Bebas_small', size: 40, tint: 0, name: 'frequency_filled_lett_' + i, align:'center', x: 0, y: -45, anchorX: 0.5, anchorY: 0},
                { type: 'shape', x: -32, y: -260, width: 64, height: 116, name: 'frequency_bar_mask_' + i },
            ], displayContainer);
            
            displayContChildren['frequency_bar_' + i].mask = displayContChildren['frequency_bar_mask_' + i];
            displayContChildren['frequency_perc_' + i].text = this.controller.model.letterFrequencies[i].toFixed(1) + '%';
            displayContChildren['frequency_lett_' + i].text = this.controller.model.alphabet[i];
            displayContChildren['frequency_filled_lett_' + i].text = '';
            let barHeight = this.controller.model.letterFrequencies[i] / 100 * this.MAX_BAR_HEIGHT * 3;
            displayContChildren['frequency_bar_' + i].y = 52 - barHeight;
            if (this.controller.model.letterFrequencies[i] === 0) {
                displayContChildren['frequency_bar_' + i].visible = false;
                displayContChildren['letterbox_' + i].texture = PIXI.Texture.from('letterbox_off.png');
            } else {
                /*
                displayContChildren['letterbox_' + i].on(event, () => {this.enterLetter(i)});
                displayContChildren['letterbox_' + i].interactive = true;
                */
                setupClicker(displayContChildren['letterbox_' + i], () => {this.enterLetter(i)});
            }

            for (let p in displayContChildren) {
                this.children[p] = displayContChildren[p];
            }
            contX += this.FREQUENCY_DISPLAYS_SPACING;
        }
    }

    createPippets(container, pages) {
        var pippetX = -((pages - 1) * this.pippetSpacing)/2;
        for (var i = 0; i < pages; i++) {
            var newPippet = null;
            if (i === 0) {
                newPippet = PIXI.Sprite.from('carousel_active.png');
            } else {
                newPippet = PIXI.Sprite.from('carousel_inactive.png');
            }
            newPippet.anchor.x = 0.5;
            newPippet.anchor.y = 0;
            newPippet.scale.x = 0.5;
            newPippet.scale.y = 0.5;
            newPippet.x = pippetX;
            container.addChild(newPippet);
            pippetX += this.pippetSpacing;
        }
    }

    updatePippets() {
        let page = Math.abs(Math.floor((this.children.sliderContainer.x + 210) / 420));
        if (page > 4) {
            page = 4;
        }
        // console.log(page);
        for (var i = 0; i < 5; i++) {
            var pippet = this.children.pippetsContainer.getChildAt(i);
            if (i === page) {
                pippet.texture = PIXI.Texture.from('carousel_active.png');
            } else {
                pippet.texture = PIXI.Texture.from('carousel_inactive.png');
            }
        }

        if (this.children.sliderContainer.x >= 0) {
            this.children.arrow_left_btn.texture = PIXI.Texture.from('arrow_left_off.png');
        } else {
            this.children.arrow_left_btn.texture = PIXI.Texture.from('arrow_left_on.png');
        }
        if (this.children.sliderContainer.x <= this.MIN_SLIDER_X) {
            this.children.arrow_right_btn.texture = PIXI.Texture.from('arrow_right_off.png');
        } else {
            this.children.arrow_right_btn.texture = PIXI.Texture.from('arrow_right_on.png');
        }
    }

    nextPage = () => {
        if (!this.popOpen) {
            let page = Math.abs(Math.floor((this.children.sliderContainer.x + 210) / 420));
            page++;
            this.gotoPage(page);
        }
    }

    prevPage = () => {
        if (!this.popOpen) {
            let page = Math.abs(Math.floor((this.children.sliderContainer.x + 210) / 420));
            page--;
            this.gotoPage(page);
        }
    }

    gotoPage(page) {
        if (page > 4) {
            page = 4;
        }
        if (page < 0) {
            page = 0;
        }
        let targetX = 0;
        if (page >= 4) {
            targetX = this.MIN_SLIDER_X;
        } else {
            targetX = -(page * 420);
        }
        this.draggingSlider = false;
        if (this.children.sliderContainer !== targetX) {
            au.play('shiftArrow', 1, false);
            gsap.killTweensOf(this.children.sliderContainer);
            gsap.to(this.children.sliderContainer, {x: targetX, duration: 0.3, onComplete: () => { this.sliderTweening = false; this.showHideSliderContent(); } });
            // this.closeKeyboard();
            this.sliderTweening = true;
        }
    }

    enableSlider() {
        if (this.slider == null) {
            var sliderHitArea = new PIXI.Graphics();
            sliderHitArea.beginFill(0, 0.5);
            sliderHitArea.drawRect(0, 30, 84 * 32 + 10, 185);
            sliderHitArea.endFill();
            sliderHitArea.interactive = true;
            sliderHitArea.alpha = 0;
            this.children.sliderContainer.addChild(sliderHitArea);
            
            this.slider = sliderHitArea;
            this.slider.on('mousedown', this.startDraggingSlider);
            this.slider.on('pointerdown', this.startDraggingSlider);
            this.slider.on('touchstart', this.startDraggingSlider);
            this.container.interactive = true;
            this.container.on('mousemove', this.dragSlider);
            this.container.on('pointermove', this.dragSlider);
            this.container.on('touchmove', this.dragSlider);
            this.container.on('mouseup', this.stopDraggingSlider);
            this.container.on('pointerup', this.stopDraggingSlider);
            this.container.on('touchend', this.stopDraggingSlider);

            document.onmouseleave = this.stopDraggingSlider;
            document.onpointerleave = this.stopDraggingSlider;
            document.onmouseup = this.stopDraggingSlider;
            document.onpointerup = this.stopDraggingSlider;

            if (this.children.scroller.visible) {
                this.children.phraseMask.on('mousedown', this.startDraggingText);
                this.children.phraseMask.on('pointerdown', this.startDraggingText);
                this.children.phraseMask.on('touchstart', this.startDraggingText);
                this.children.phraseMask.interactive = true;
            }

            if (this.children.scroller.visible) {
                this.children.scroller.on('mousedown', this.startDraggingScroller);
                this.children.scroller.on('pointerdown', this.startDraggingScroller);
                this.children.scroller.on('touchstart', this.startDraggingScroller);
                this.children.scroller.interactive = true;
            }
        }
        this.updatePippets();
        this.draggingSlider = false;
        this.draggingText = false;
    }

    clearSlider() {
        if (this.slider) {
            this.slider.interactive = false;
            this.container.interactive = false;
            this.slider.parent.removeChild(this.slider);
            this.slider = null;
            while (this.children.pippetsContainer.children.length > 0) {
                let c = this.children.pippetsContainer.children[0];
                this.children.pippetsContainer.removeChild(c);
                c.destroy();
            }
            this.draggingSlider = false;
        }
    }

    draggingSlider = false;
    draggingText = false;
    draggingScroller = false;
    startMouseX = null;
    startSliderX = null;
    startMouseY = null;
    startTextY = null;
    startScrollerY = null;
    MAX_SLIDER_X = 0;
    MIN_SLIDER_X = -1770;
    startDraggingSlider = (e) => {
        if (!this.popOpen) {
            gsap.killTweensOf(this.children.sliderContainer);
            this.draggingSlider = true;
            this.startMouseX = this.container.toLocal(e.data.global).x;
            this.startSliderX = this.children.sliderContainer.x;
            this.enterLetter(-1);
            this.lastDragAmount = 0;
            // this.closeKeyboard();
        }
    }

    startDraggingText = (e) => {
        if (!this.popOpen) {
            // console.log('start dragging text');
            this.draggingText = true;
            this.startMouseY = this.container.toLocal(e.data.global).y;
            this.startTextY = this.richText.y;
            // this.closeKeyboard();
        }
    }

    startDraggingScroller = (e) => {
        if (!this.popOpen) {
            this.draggingScroller = true;
            this.startMouseY = this.container.toLocal(e.data.global).y;
            this.startScrollerY = this.children.scroller.y;
            // this.closeKeyboard();
        }
    }

    lastDragAmount = 0;
    dragSlider = (e) => {
        if (this.draggingScroller) {
            let thisPoint = this.container.toLocal(e.data.global);
            let moveDistance = thisPoint.y - this.startMouseY;
            let newY = this.startScrollerY + moveDistance;
            if (newY > this.scrollerStart + this.scrollerMax) {
                newY = this.scrollerStart + this.scrollerMax;
            }
            if (newY < this.scrollerStart) {
                newY = this.scrollerStart;
            }
            this.children.scroller.y = newY;
            let movePerc = Math.abs(this.children.scroller.y - this.scrollerStart) / this.scrollerMax;
            this.richText.y = this.textScrollStart - movePerc * this.textScrollDist;
        } else;
        if (this.draggingSlider) {
            let thisPoint = this.container.toLocal(e.data.global);
            let moveDistance = thisPoint.x - this.startMouseX;
            let newX = this.startSliderX + moveDistance;
            if (newX > this.MAX_SLIDER_X) {
                newX = this.MAX_SLIDER_X;
            }
            if (newX < this.MIN_SLIDER_X) {
                newX = this.MIN_SLIDER_X;
            }
            let dragDelta = newX - this.children.sliderContainer.x;
            if (dragDelta !== 0) {
                this.lastDragAmount = dragDelta;
                setTimeout(() => {if (this.draggingSlider) this.lastDragAmount = 0}, 200);
            }
            this.children.sliderContainer.x = newX;
            this.showHideSliderContent();
        } else
        if (this.draggingText) {
            let thisPoint = this.container.toLocal(e.data.global);
            let moveDistance = thisPoint.y - this.startMouseY;
            let newY = this.startTextY + moveDistance;
            if (newY > this.textScrollStart) {
                newY = this.textScrollStart;
            }
            if (newY < this.textScrollMin) {
                newY = this.textScrollMin;
            }
            this.richText.y = newY;
            let movePerc = Math.abs(this.richText.y - this.textScrollStart) / Math.abs(this.textScrollStart - this.textScrollMin);
            this.children.scroller.y = this.scrollerStart + movePerc * this.scrollerMax;
        }
    }

    stopDraggingSlider = (e) => {
        this.draggingSlider = false;
        this.draggingText = false;
        this.draggingScroller = false;
    }

    dragInertia(delta = 1) {
        if (!this.draggingSlider && this.lastDragAmount !== 0) {
            let newX = this.children.sliderContainer.x + this.lastDragAmount * delta;
            if (newX > this.MAX_SLIDER_X) {
                newX = this.MAX_SLIDER_X;
            }
            if (newX < this.MIN_SLIDER_X) {
                newX = this.MIN_SLIDER_X;
            }
            this.children.sliderContainer.x = newX;
            this.lastDragAmount *= 0.9 * delta;
            if (Math.abs(this.lastDragAmount) < 0.1) {
                this.lastDragAmount = 0;
            }
            this.showHideSliderContent();
        }
    }

    showHideSliderContent = () => {
        let vp = app.viewPort;
        let l = vp.left;
        let r = vp.right;
        if (l === 0) {
            l = -vp.x;
            r = vp.width + vp.x;
        }
        for (let i = 0; i < 26; i++) {
            let displayContainer = this.children['frqCont_' + i];
            let globalPos = displayContainer.toGlobal({x: 0, y: 0});
            let mainContainerPos = this.container.toLocal(globalPos);
            if (mainContainerPos.x < l - 100 || mainContainerPos.x > r + 100) {
                displayContainer.visible = false;
            } else {
                displayContainer.visible = true;
            }
        }
    }

    currentLetterEnterIndex = -1;
    enterLetter(index) {
        // we need to check the index here because -1 causes us to stop looking for input
        if ((!this.clickAllowed || this.popOpen) && index >= 0) {
            return;
        }
        this.clickAllowed = false;

        if (this.currentLetterEnterIndex >= 0) {
            gsap.killTweensOf(this.children['letterbox_' + this.currentLetterEnterIndex]);
            this.children['letterbox_' + this.currentLetterEnterIndex].alpha = 1;
        }
        if (index >= 0) {
            gsap.to(this.children['letterbox_' + index], {alpha: 0.2, repeat: -1, yoyo: true, duration: 0.3});
        }
        this.currentLetterEnterIndex = index;
        if (index >= 0) {
            au.play('button', 1, false);
            this.controller.enterDescrambleAttemptLetter(this.currentLetterEnterIndex, '');
        }
        if (/*koko.client.system.isMobile &&*/ index >= 0) {
            /*
            let c = prompt('Enter letter for ' + this.controller.model.alphabet[index]);
            let l = c === null ? '' : c.substr(0, 1);
            this.controller.enterDescrambleAttemptLetter(this.currentLetterEnterIndex, l);
            this.updateDescrambleAttempt();
            this.enterLetter(-1);
            */
            this.openKeyboard();
        }
    }

    keyPressed = (e) => {
        if (!koko.client.system.isMobile && !this.popOpen) {
            // console.log(e);
            if (this.currentLetterEnterIndex >= 0) {
                this.controller.enterDescrambleAttemptLetter(this.currentLetterEnterIndex, e.key);
                this.updateDescrambleAttempt();
                // this.enterLetter(-1);
            }
        }
    }

    clearAllLetters = () => {
        this.controller.clearAllLetters();
        this.updateDescrambleAttempt();
    }

    updateDescrambleAttempt() {
        let lettersEnteredCount = 0;
        for (let i = 0; i < 26; i++) {
            this.children['frequency_filled_lett_' + i].text = this.controller.model.descrambleAttempt[i];
            if (this.controller.model.letterFrequencies[i] === 0) {
                this.children['letterbox_' + i].texture = PIXI.Texture.from('letterbox_off.png');
                lettersEnteredCount++;
            } else
            if (this.controller.model.descrambleAttempt[i] === '') {
                this.children['letterbox_' + i].texture = PIXI.Texture.from('letterbox_missing.png');
            } else {
                this.children['letterbox_' + i].texture = PIXI.Texture.from('letterbox_populated.png');
                lettersEnteredCount++;
            }
        }
        let messageToDisplay = this.controller.model.scrambledPhrase.split('');
        for (let i = 0; i < messageToDisplay.length; i++) {
            let index = this.controller.model.alphabet.indexOf(messageToDisplay[i]);
            if (index >= 0 && this.controller.model.descrambleAttempt[index] !== '') {
                messageToDisplay[i] = '<blue>' + this.controller.model.descrambleAttempt[index] + '</blue>';
            }
            this.richText.text = messageToDisplay.join('').split('|').join('\n');
        }
        if (lettersEnteredCount >= 26) {
            this.submissionAllowed = true;
            this.children.checkAnswer_btn.texture = PIXI.Texture.from('checkAnswer_btn.png');
        } else {
            this.submissionAllowed = false;
            this.children.checkAnswer_btn.texture = PIXI.Texture.from('checkAnswerOff_btn.png');
        }
        let keysToHighlight = this.submissionAllowed ? this.controller.model.alphabet : this.controller.model.descrambleAttempt;
        this.customKeyboard.highlightKeys(keysToHighlight);
        if (this.submissionAllowed) {
            this.closeKeyboard();
        }
    }

    submitAnswer = (e) => {
        if (this.keyboardOpen) {
            this.closeKeyboard();
        }
        if (this.submissionAllowed && !this.popOpen) {
            if (this.controller.checkAnswer()) {
                au.play('correct', 1, false);
                this.stopGame();
                gameState.setGameScore(this.timeController.rank);
                // this.transitionOut();
                this.popOpen = true;
                v.get('gameover').transitionIn();
            } else {
                au.play('wrong', 1, false);
                this.popOpen = true;
                v.get('ingamehud').enabled = false;
                v.get('wronganswer').transitionIn(this);
            }
        }
    }

    popClosed = () => {
        if (this.popOpen) {
            this.popOpen = false;
            this.clickAllowed = true;
            v.get('ingamehud').enabled = true;
        }
    }

    showQuitPop = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            v.get('ingamehud').enabled = false;
            v.get('quitpopup').transitionIn(this);
            this.stopDraggingSlider();
            this.closeKeyboard();
            this.enterLetter(-1);
        }
    }

    showClearPop = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            v.get('ingamehud').enabled = false;
            v.get('clearpopup').transitionIn(this);
            this.stopDraggingSlider();
            this.closeKeyboard();
            this.enterLetter(-1);
        }
    }

    showHint = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            v.get('ingamehud').enabled = false;
            v.get('frhint').transitionIn(this);
        }
    }

    showTutorial = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            v.get('ingamehud').enabled = false;
            v.get('frtutorial').transitionIn(this);
        }
    }

    openKeyboard = () => {
        if (!this.keyboardOpen && !this.popOpen) {
            let vp = app.viewPort;
            this.customKeyboard = new SimpleCustomKeyboard(keyboardSetup_Fr);
            this.keyboardView = this.customKeyboard.createKeyboard(vp.centerX, 1044, this.container, this.handleCustomKeyboardClick, 0);
            this.keyboardView.alpha = 0;
            this.keyboardOpen = true;
            let keysToHighlight = this.submissionAllowed ? this.controller.model.alphabet : this.controller.model.descrambleAttempt;
            this.customKeyboard.highlightKeys(keysToHighlight);
            gsap.to(this.keyboardView, {alpha:1, duration: 0.35});
            /*
            let currentVal = this.answerInput.val;
            this.children.answerText.text = currentVal + '|';
            */
        } /*else
        if (this.keyboardOpen && !this.popOpen) {
            this.closeKeyboard();
        }*/
    }

    closeKeyboard = () => {
        if (this.keyboardOpen) {
            this.keyboardOpen = false;
            gsap.to(this.keyboardView, {alpha:0, duration: 0.35, onComplete: this.customKeyboard.removeKeyboard});
            /*
            let currentVal = this.answerInput.val;
            if (currentVal !== '') {
                this.children.answerText.text = currentVal;
            } else {
                this.children.answerText.text = 'ANSWER';
            }
            */
            this.enterLetter(-1);
        }
    }

    handleCustomKeyboardClick = (kId, e) => {
        if (this.keyboardOpen && !this.popOpen) {
            console.log('custom keyboard: ', kId, e);
            if (kId.toUpperCase() === 'CLEAR') {
                this.showClearPop();
            } else
            if (kId.toUpperCase() === 'CLOSE') {
                this.closeKeyboard();
            } else {
                // let currentVal = this.answerInput.val;
                if (kId.toUpperCase() === 'SPC' || kId.toUpperCase() === 'SPACE') {
                    // currentVal += ' ';
                    this.controller.enterDescrambleAttemptLetter(this.currentLetterEnterIndex, '');
                } else
                if (kId.toUpperCase() === 'DEL') {
                    /*
                    if (currentVal.length > 0) {
                        currentVal = currentVal.substr(0, currentVal.length - 1);
                    }
                    */
                    this.controller.enterDescrambleAttemptLetter(this.currentLetterEnterIndex, '');
                } else {
                    // currentVal += kId;
                    let l = kId === null ? '' : kId;
                    this.controller.enterDescrambleAttemptLetter(this.currentLetterEnterIndex, l);
                }
                // this.answerInput.val = currentVal;
                // this.children.answerText.text = currentVal + '|';
                this.updateDescrambleAttempt();
                // this.enterLetter(-1);
                // this.closeKeyboard();
            }
        }
    }
}